export const AUTOMATION_META = '_item_meta';

export type AutomationMetaButton = {
    type: 'button';
    disabled: boolean;
    over: boolean;
    pressed: boolean;
};

export type AutomationMetaSimpleButton = {
    type: 'button_simple';
};

export type AutomationMetaText = {
    type: 'text';
    text: string;
    textTemplate?: string;
};

export type AutomationMetaAnimation = {
    type: 'animation';
    loop: boolean;
    isPlaying: boolean;
};

export type AutomationMetaCheckbox = {
    type: 'checkbox';
    disabled: boolean;
    checked: boolean;
};

export type AutomationMetaMovieClip = {
    type: 'movie_clip';
    frame: number;
};

export type AutomationMetaSpine = {
    type: 'spine';
    isPlaying: boolean;
    skin: string;
    animations: string[];
};

export type AutomationMetaAny = Record<string, string|number|boolean|(string|number|boolean)[]>;

export type AutomationMeta =
    AutomationMetaButton
    | AutomationMetaSimpleButton
    | AutomationMetaText
    | AutomationMetaCheckbox
    | AutomationMetaMovieClip
    | AutomationMetaSpine
    | AutomationMetaAnimation;

